import { Box, Button, FormControl } from "@mui/material";
import Select from "react-select";
import React, { useContext, useEffect, useState } from "react";
import { itemsCenter } from "../../utilities/commonStyles/commonStyles";
import {
  fetchDivisions,
  fetchTeacherData,
  getLevels,
} from "../../utilities/const/functions";
import { AuthContext } from "../../utilities/context/AuthContext";
import ClassDiv from "./ClassDiv";
import { reactSelectTheme } from "../../utilities/const/const";
const init = {
  classCode: "all",
  level: "all",
  teacher: "all",
};
const Attendance = ({ data, classCodeData }) => {
  // console.log({ classCodeData });
  const [classes, setClasses] = useState([]);
  const { setLoading } = useContext(AuthContext);
  const [divisions, setDivisions] = useState([]);
  const [levels, setLevels] = useState([]);
  const [search, setSearch] = useState(init);
  const [searchData, setSearchData] = useState([]);
  const [teachers, setTeachers] = useState([]);

  const fetchInitData = async () => {
    setDivisions([]);
    setLevels([]);
    setTeachers([]);
    try {
      setLoading(true);
      const levelRes = await getLevels();
      if (!levelRes?.error) {
        setLevels(levelRes?.data);
      }
      const divisionRes = await fetchDivisions();
      if (!divisionRes.error) {
        setDivisions(divisionRes.data);
      }
      const teacherRes = await fetchTeacherData();
      if (!teacherRes?.error) {
        setTeachers(teacherRes?.data);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const getTeacherName = (id) => {
    let name = teachers.filter((e) => {
      return e.id == id;
    });

    return name[0]?.name ?? "NA";
  };
  const getLevelName = (id) => {
    let name = levels.filter((e) => {
      return e.id == id;
    });

    return name[0]?.name ?? "NA";
  };
  const getDivisionImage = (id) => {
    let image = divisions.filter((e) => {
      return e.id == id;
    });

    return image[0]?.image ?? "";
  };

  const handleSearch = () => {
    let data = classes;
    // console.log({ data });
    if (search.classCode !== "all") {
      data = data.filter((e) => {
        // console.log({ e });
        // console.log({ search });
        return e.id === search.classCode;
      });
    } else if (search.level !== "all") {
      data = data.filter((e) => {
        // console.log({ e });
        // console.log({ search });
        return e.level === search.level;
      });
    } else if (search.teacher !== "all") {
      data = data.filter((e) => {
        // console.log({ e });
        // console.log({ search });
        return e.teacher === search.teacher;
      });
    }
    // console.log({ data });
    setSearchData(data);
  };

  useEffect(() => {
    // setClasses(data.classCode);
    // setSearchData(data.classCode);
    setClasses(classCodeData);
    setSearchData(classCodeData);

    fetchInitData();
  }, [data, classCodeData]);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          width: "80%",
        }}
      >
        <FormControl sx={{ m: 1, width: 250 }}>
          {/* <InputLabel>Filter by Class Code</InputLabel> */}
          <Select
            placeholder="Select ClassCode"
            value={classes.find((obj) => obj.id === search.classCode) ?? null}
            theme={reactSelectTheme}
            styles={{
              control: (provided) => ({
                ...provided,
                height: "42px",
                minWidth: "200px",
                maxWidth: "240px",
              }),
            }}
            options={classes
              .slice()
              .sort((a, b) => a.classCode.localeCompare(b.classCode))}
            getOptionLabel={(options) => options.classCode}
            getOptionValue={(option) => option.id}
            onChange={(e) => {
              setSearch({
                ...init,
                classCode: e.id,
              });
            }}
          />
        </FormControl>
        <FormControl sx={{ m: 1, width: 200 }}>
          <Select
            placeholder="Select Level"
            value={levels.find((obj) => obj.id === search.level) ?? null}
            theme={reactSelectTheme}
            styles={{
              control: (provided) => ({
                ...provided,
                height: "42px",
              }),
            }}
            options={levels
              .slice()
              .sort((a, b) => a.name.localeCompare(b.name))}
            getOptionLabel={(options) => options.name}
            getOptionValue={(option) => option.id}
            onChange={(e) => {
              setSearch({
                ...init,
                level: e.id,
              });
            }}
          />
        </FormControl>
        <FormControl sx={{ m: 1, width: 250 }}>
          <Select
            placeholder="Select Teacher"
            value={teachers.find((obj) => obj.id === search.teacher) ?? null}
            theme={reactSelectTheme}
            styles={{
              control: (provided) => ({
                ...provided,
                height: "42px",
                width: "200px",
              }),
            }}
            options={teachers
              .slice()
              .sort((a, b) => a.name.localeCompare(b.name))}
            getOptionLabel={(options) => options.name}
            getOptionValue={(option) => option.id}
            onChange={(e) => {
              setSearch({
                ...init,
                teacher: e.id,
              });
            }}
          />
        </FormControl>
        <Box sx={{ ...itemsCenter, gap: "10px", width: "30%" }}>
          <Button
            onClick={handleSearch}
            sx={{
              background: "#FFFFFF",
              boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.25)",
              borderRadius: "6px",
              padding: "5px 10px",
              color: (theme) => theme.palette.secondary.main,
              "&:hover": {
                background: "#FFFFFF",
              },
            }}
          >
            Filter
          </Button>
          <Button
            onClick={() => {
              setSearchData(classCodeData);
              setSearch(init);
            }}
            sx={{
              // boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.25)",
              borderRadius: "6px",
              padding: "5px 10px",
              color: (theme) => theme.palette.secondary.main,
              "&:hover": {
                background: "#FFFFFF",
              },
            }}
          >
            Clear Filter
          </Button>
        </Box>

        {/* <Button
          sx={{
            ...flexCenter,
            width: "150px",
            gap: "5px",
            color: (theme) => theme.palette.primary.main,
            backgroundColor: "transparent",
            border: "1px solid #E6007E",
            padding: "5px 10px",
            "&:hover": { backgroundColor: "transparent" },
          }}
        >
          <ExcelIcon />
          Send to Excel
        </Button> */}
      </Box>

      {searchData?.map((e) => (
        <ClassDiv
          key={e.id}
          data={e}
          studentInfo={data}
          getTeacherName={getTeacherName}
          getLevelName={getLevelName}
          getDivisionImage={getDivisionImage}
        />
      ))}
    </Box>
  );
};

export default Attendance;
